/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Colleague_Filter_EngineerInputs */

const en_colleague_filter_engineer = /** @type {(inputs: Colleague_Filter_EngineerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Field engineer`)
};

const ja_colleague_filter_engineer = /** @type {(inputs: Colleague_Filter_EngineerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`フィールドエンジニア`)
};

const fr_colleague_filter_engineer = /** @type {(inputs: Colleague_Filter_EngineerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Technicien`)
};

const de_colleague_filter_engineer = /** @type {(inputs: Colleague_Filter_EngineerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Techniker`)
};

/**
* | output |
* | --- |
* | "Field engineer" |
*
* @param {Colleague_Filter_EngineerInputs} inputs
* @param {{ locale?: "en" | "ja" | "fr" | "de" }} options
* @returns {LocalizedString}
*/
export const colleague_filter_engineer = /** @type {((inputs?: Colleague_Filter_EngineerInputs, options?: { locale?: "en" | "ja" | "fr" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Colleague_Filter_EngineerInputs, { locale?: "en" | "ja" | "fr" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_colleague_filter_engineer(inputs)
	if (locale === "ja") return ja_colleague_filter_engineer(inputs)
	if (locale === "fr") return fr_colleague_filter_engineer(inputs)
	return de_colleague_filter_engineer(inputs)
});